import Api from './Api';

export default {
	getProductSlider(data) {
		return Api.post('get_product_slider', data);
	},
	getSingleProductSlider(id) {
		return Api.get('get_single_product_slider?id=' + id);
	},
};
